window.Alert = (titulo, tipo) => {
  return swal({
    icon: tipo,
    title: titulo,
    button: {
      text: "Aceptar",
      closeModal: true,
    },
  })
}

window.AlertConfirm = (titulo, tipo = "warning", aceptarTex = "Aceptar", cancelarText = "Cancelar") => {
  return swal({
    title: titulo,
    icon: tipo,
    buttons: { cancel: cancelarText, ok: aceptarTex, },
    dangerMode: true,
  })
}
